import { RecordBase } from '../../providers/request/record-base.model';
import { ArchiveFileSyncRuleType } from './archive-file-sync-rule-type.enum';
export class ArchiveFileSyncRule extends RecordBase {
  catalogId?: number;
  type?: ArchiveFileSyncRuleType;
  content?: string;
  checked?: boolean;
  sortOrder?: number;
  comment?: string;

  constructor(type: ArchiveFileSyncRuleType) {
    super();
    this.type = type;
    this.content = '';
    this.checked = false;
  }
}
